import { StrictMode, ReactNode, ComponentType } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';

import { ErrorBoundary } from './ErrorBoundary';
import { store } from '../../state/store';
import { Contexts } from './Contexts';

type ProvidersProps = {
  LDProvider?: ComponentType<{ children: ReactNode }>;
  children: ReactNode;
};

export const Providers = ({
  LDProvider = ({ children }) => children,
  children
}: ProvidersProps) => {
  return (
    <StrictMode>
      <ErrorBoundary>
        <LDProvider>
          <ReduxProvider store={store}>
            <BrowserRouter basename={process.env.VITE_PATH_PREFIX}>
              <Contexts>{children}</Contexts>
            </BrowserRouter>
          </ReduxProvider>
        </LDProvider>
      </ErrorBoundary>
    </StrictMode>
  );
};
